export interface MicroreelLesson {
  id: string;
  title: string;
  description: string;
  poster?: string;
  folderId: string;
  order: number;
  isPublished: boolean;
  libraryMediaFileId?: string;
}

export interface MicroreelFolder {
  id: string;
  name: string;
  description?: string;
  image?: string;
  courseId: string;
  order: number;
  isPublished: boolean;
  lessons: MicroreelLesson[];
}

export interface MicroreelGroup {
  id: string;
  dateCreated: Date;
  dateUpdated: Date;
  organizationId: string;
  title: string;
  subjectTitle?: string;
  type: number;
  isPublic: boolean;
  image?: string;
  enrollNumber: number;
  completedNumber: number;
  averageGrade?: number;
  published: boolean;
  publishedCourseId?: string;
  accessRestricted: boolean;
  folders: MicroreelFolder[];
  projectId?: string | null;
  projectName?: string | null;
}

// The list endpoint returns lessons in DB insertion order, so sorting by
// `order` here is what makes persisted reordering visible after a reload.
export const getGroupReels = (group?: MicroreelGroup): MicroreelLesson[] =>
  group?.folders?.flatMap(folder =>
    [...(folder.lessons ?? [])].sort((a, b) => a.order - b.order),
  ) ?? [];
